import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default new Vuex.Store({
  state: {
    loadFaceApi: false,
    version: "1.2",
    isNewer: true,
  	history: [],
    gender: "none",
	internetStatus: false,
	userInfo: {},
    contents: {},
    fastAds: ["40801", "40790"],
	base64Picture: [],
	loadingScreen: false,
	topGames: [],
    topHomes: [],
    lang: ["en", "es", "id", "ms", "pt", "th", "tr", "vi","hi", "km", "ph", "el", "ar", "fr","ja","zh","pl","nl","ro","de","it","np", "ur", "ps", "uz", "hu","sr","bn","kk","az","my", "fa", "te", "ta", "sw", "pa", "mr", "he", "lo", 'am', 'om', 'ka', 'bg', 'ru', 'sv', 'no', 'fi', 'cs', 'da', 'hr', 'sk', 'uk', "sv", "no", "mn", "si"],
	photo_filter_cache: {
		profile: [],
		friends: []
	},
	result : "",
	GoogleAnalytics: "UA-157888438-1",
	FBmyInterstitials: [""],
	FBpreloadedInterstitial: null,
	FBwaitTillShow: 0,
	FBinterval: 40000,
	interval: 2,
	FBintervalStep: 10000,
    base64Draw: null,
    timeResult: 100,
	adsTimeout: true,
	stag: 'await',
	played: 1,
	pageview: 1,
	countError: 0,
    apiGender: 'https://ahquiz.me/gender/',

    
 //    urlInapp: 'https://images.ahaquiz.me/1_@ahatest/images/',
 //    urlImage: 'https://images.ahaquiz.me/1_@ahatest/images/',
	// urlHome: 'https://img.ahaquiz.me/1_@ahatest/',
	// urlHomeTry: 'staticc/data/',
	// urlJson: 'https://img.ahaquiz.me/1_@ahatest/',
	// urlJsonTry: 'staticc/data/',


    

    urlInapp: 'https://img.ahaquiz.me/aha/images/',
    urlImage: 'https://img.ahaquiz.me/aha/images/',
    urlHome: 'https://img.ahaquiz.me/aha/data/',
    urlHomeTry: 'static/data/',
    urlJson: 'https://img.ahaquiz.me/aha/data/',
    urlJsonTry: 'static/data/',

	languages: [{
        code: "vi",
        located_name: "vietnamese",
        name: "Việt Nam"
    },
    {
        code: "tr",
        located_name: "Türkçe",
        name: "Türkçe"
    },
   
    {
       code: "id",
        located_name: "indonesian",
        name: "Indonesia"
    },
    {
        code: "th",
        located_name: "ไทย",
        name: "ไทย"
    },
    {
        code: "ms",
        located_name: "Malay",
        name: "Malay"
    },
    {
        code: "en",
        located_name: "english",
        name: "English"
    },
    {
        code: "ph",
        located_name: "Filipino",
        name:"Filipino"
    },
     {
        code: "ar",
        located_name: "عربی",
        name:"عربی"
    },
    {
        code: "fr",
        located_name: "Français",
        name: "Français"
    },
    {
        code: "pt",
        located_name: "brasil",
        name: " Português"
    },
    // {
    //     code: "uk",
    //     located_name: "українська",
    //     name: " українська"
    // },
    {
        code: "km",
        located_name: "ខ្មែរ",
        name: " ខ្មែរ"
    },
    {
        code: "es",
        located_name: "Español",
        name: "Español"
    },
    {
        code: "ro",
        located_name: "România",
        name: "România"
    },
    {
        code: "bn",
        located_name: "Bengali",
        name: "Bengali"
    },
    {
        code: "pl",
        located_name: "Polski",
        name: "Polski"
    },
    {
        code: "el",
        located_name: "Ελληνικά",
        name: "Ελληνικά"
    },
    {
        code: "zh",
        located_name: "繁體中文",
        name: "繁體中文"
    },
    {
        code: "ja",
        located_name: "日本語",
        name: "日本語"
    },
    {
        code: "it",
        located_name: "Italiano",
        name: "Italiano"
    },
    
    {
        code: "de",
        located_name: "Deutsch",
        name: "Deutsch"
    },
    {
        code: "uz",
        located_name: "o‘zbek",
        name: "o‘zbek"
    },
    {
        code: "hu",
        located_name: "Hungari",
        name: "Hungari"
    },
    {
        code: "sr",
        located_name: "Serbia",
        name: "Serbia"
    },
    {
        code: "tg",
        located_name: "Tajiks",
        name: "Tajiks"
    },
    {
        code: "nl",
        located_name: "Nederlands",
        name: "Nederlands"
    },
    {
        code: "pl",
        located_name: "Polski",
        name: "Polski"
    },
    {
        code: "hi",
        located_name: "Hindi",
        name: "Hindi"
    },
    {
        code: "np",
        located_name: "Nepali",
        name: "Nepali"
    },
     {
        code: "ur",
        located_name: "اردو",
        name: "اردو"
    },
    {
        code: "ps",
        located_name: "دری",
        name: "Ba Tư"
    },
    {
        code: "kk",
        located_name: "Kazakhstan",
        name: "Kazakhstan"
    },
    {
        code: "az",
        located_name: "Azerbaijain ",
        name: "Azerbaijain "
    },
    {
        code: "fa",
        located_name: "Pashto ",
        name: "Pashto "
    },
    {
        code: "my",
        located_name: "Myanmar",
        name: "Myanmar"
    },
    {
        code: "te",
        located_name: "Telugu",
        name: "Telugu"
    },
     {
        code: "pa",
        located_name: "Punjab",
        name: "Punjab"
    },
    {
        code: "ta",
        located_name: "Tamil",
        name: "Tamil"
    },
    {
        code: "sw",
        located_name: "Swahili",
        name: "Swahili"
    },
    {
        code: "lo",
        located_name: "Lào",
        name: "Lào"
    },
    {
        code: "he",
        located_name: "Do Thái",
        name: "Do Thái"
    },
    {
        code: "mr",
        located_name: "Marathi",
        name: "Marathi"
    },
    {
        code: "om",
        located_name: "Oromo",
        name: "Oromo"
    },
    {
        code: "am",
        located_name: "Amharic",
        name: "Amharic"
    },
    {
        code: "ka",
        located_name: "ქართული",
        name: "George"
    },
    {
        code: "bg",
        located_name: "Български",
        name: "Bulgaria"
    },
    {
        code: "ru",
        located_name: "Pусский",
        name: "Pусский"
    }, 

    ]
  },
  mutations,
  actions,
  getters
});
